// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.label-container {
    height: 50px;
    background-color: #C1D47B;
    color: #5D6E41;
    cursor: pointer;
}
.label-container-selected {
    background-color: #5D6E41;
    color: #f0f0f0;
}
.label-container > div {
    font-weight: 500;
    padding-top: 10px;
    text-align: center;
}
.overlay-cell {
    position: absolute;
    z-index: 10;
    top: 5px;
    left: 5px;
    font-size: 12px;
    font-weight: 700;
    color: #436594;
    pointer-events: none;
}
.overlay-event {
    position: absolute;
    z-index: 12;
    top: 40px;
    left: 5px;
    font-size: 16px;
    width: 95%;
    text-align: center;
    pointer-events: none;
}
.overlay-container {
    position: relative;
    z-index: 1;
}
.cell-container {
    height: 100px;
    background-color: #ffffff;
    border: 1px solid #cccccc;
    margin-bottom: 10px;
}
.left-cell {
    width: 50%;
    background-color: #f0f0f0;
    height: 100%;
    cursor: pointer;
}
.right-cell {
    width: 50%;
    background-color: #FDFFCB;
    height: 100%;
    cursor: pointer;
    border-left: 1px solid #efecec;
}
.whole-cell {
    width: 100%;
    background-color: #f0f0f0;
    height: 100%;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./ClientApp/components/oeeconfigui/oeeconfigui.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;IACT,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB","sourcesContent":["\n.label-container {\r\n    height: 50px;\r\n    background-color: #C1D47B;\r\n    color: #5D6E41;\r\n    cursor: pointer;\n}\n.label-container-selected {\r\n    background-color: #5D6E41;\r\n    color: #f0f0f0;\n}\n.label-container > div {\r\n    font-weight: 500;\r\n    padding-top: 10px;\r\n    text-align: center;\n}\n.overlay-cell {\r\n    position: absolute;\r\n    z-index: 10;\r\n    top: 5px;\r\n    left: 5px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    color: #436594;\r\n    pointer-events: none;\n}\n.overlay-event {\r\n    position: absolute;\r\n    z-index: 12;\r\n    top: 40px;\r\n    left: 5px;\r\n    font-size: 16px;\r\n    width: 95%;\r\n    text-align: center;\r\n    pointer-events: none;\n}\n.overlay-container {\r\n    position: relative;\r\n    z-index: 1;\n}\n.cell-container {\r\n    height: 100px;\r\n    background-color: #ffffff;\r\n    border: 1px solid #cccccc;\r\n    margin-bottom: 10px;\n}\n.left-cell {\r\n    width: 50%;\r\n    background-color: #f0f0f0;\r\n    height: 100%;\r\n    cursor: pointer;\n}\n.right-cell {\r\n    width: 50%;\r\n    background-color: #FDFFCB;\r\n    height: 100%;\r\n    cursor: pointer;\r\n    border-left: 1px solid #efecec;\n}\n.whole-cell {\r\n    width: 100%;\r\n    background-color: #f0f0f0;\r\n    height: 100%;\r\n    cursor: pointer;\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
